import { LoadSpinner } from '@calizahq/react-components-v2'
import styled from '@emotion/styled'
import { PotentialBookingsMutations } from '@sales-app/graphql/mutations/potentialBookings.mutations'
import { AgentQueries } from '@sales-app/graphql/queries/agent.queries'
import { usePotentialBookings } from '@sales-app/hooks/usePotentialBookings/usePotentialBookings'
import { useDebounce } from '@shared/hooks'
import { Row } from '@tanstack/react-table'
import React, { ChangeEvent, useState } from 'react'

import { Dropdown } from '@/components'
import { useAlertContext } from '@/context'
import { useGraphql, useGraphqlMutation } from '@/hooks/useGraphql'

type Props = {
  rowSelected: Row<any>[]
}

export const AssignFilter = ({ rowSelected }: Props) => {
  const [dropdownExpanded, setDropdownExpanded] = useState(false)
  const { refetch } = usePotentialBookings()
  const { setAlert } = useAlertContext()

  const { mutate } = useGraphqlMutation(PotentialBookingsMutations.updateAgentForPotentialBookings(), {
    onSuccess: () => {
      refetch()
      setAlert('Assigned agent updated', 'success')
    },
  })

  const [searchString, setSearchString] = useState<string>()
  const debouncedSearch = useDebounce(searchString, 1000)
  const { data, isLoading } = useGraphql<AgentQueries.GET_SEARCH_AGENT.Response>(
    AgentQueries.getSearchAgent.name,
    AgentQueries.getSearchAgent(),
    {
      searchString: debouncedSearch,
    },
  )

  const assignPotentialBooking = (id?: number) => {
    const selectedPotentialBookingIDs = rowSelected.map((d) => d.original.id)

    setDropdownExpanded(false)
    if (selectedPotentialBookingIDs && selectedPotentialBookingIDs.length && id) {
      mutate({
        agentId: id,
        potentialBookingIds: selectedPotentialBookingIDs,
      })
    }
  }

  const handleSearch = (e: ChangeEvent<HTMLInputElement>) => {
    e.preventDefault()
    setSearchString(e.target.value)
  }

  return (
    <>
      <Dropdown
        className="mr-4 hidden w-full md:w-auto lg:flex"
        expanded={dropdownExpanded}
        headerTitle="Assign Agent"
        onHideDropdown={() => setDropdownExpanded(false)}
        renderHeader={() => <div></div>}
        setExpanded={setDropdownExpanded}
      >
        <AssignFilterOptionsStyled>
          <div className="flex w-full px-4">
            <input
              autoComplete="off"
              className="mb-2  w-full rounded border-2 border-border-secondary p-2 focus:outline-none"
              onChange={handleSearch}
              placeholder="Search"
              value={searchString || ''}
            />
          </div>
          <div className="flex w-full">
            {isLoading ? (
              <div className="flex h-24 w-full items-center justify-center">
                <LoadSpinner className="icon-secondary" isCurrentColor={true} size={2} />
              </div>
            ) : (
              <div className="flex max-h-48 min-h-24 w-full overflow-scroll">
                {data && data?.agents?.length && (
                  <ul>
                    {data?.agents.map((agent) => (
                      <li key={agent.id} onClick={() => assignPotentialBooking(agent.id)} role={'presentation'}>
                        {agent.name}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            )}
          </div>
        </AssignFilterOptionsStyled>
      </Dropdown>
    </>
  )
}

export const AssignFilterOptionsStyled = styled.div`
  width: 13rem;
  display: flex;
  flex-direction: column;
  padding-top: 1rem;
  padding-bottom: 1rem;

  ul {
    width: 100%;
    padding-top: 0.5rem;
    padding-bottom: 0.25rem;
  }
  li {
    margin-bottom: 0.25rem;
    padding-left: 1rem;
    padding-right: 1rem;
    width: 100%;
    cursor: pointer;
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
    line-height: 1;
    &:hover {
      background-color: #f3f3f2;
    }
  }
`
